<template>
  <div class="topXzl-fgx">
    <div class="topXzl-fgx-title" v-if="title">
      {{title}}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    }
  }
};
</script>

<style lang='scss'>
.topXzl-fgx {
  border-bottom: 1px dashed rgb(222, 222, 222);
  padding: 8px;
  margin-bottom: 20px;
  .topXzl-fgx-title {
    left: 0;
    top: 0;
    font-size: 12px;
    padding: 5px 10px;
    position: absolute;
    border-radius: 3px;
    transform: translateY(-50%);
    background: rgb(227, 227, 227);
  }
}
</style>